import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material/styles';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';

type ErrorMessageProps = {
  message?: string;
  'data-testid'?: string;
};

const ErrorMessage = ({ message, ...props }: ErrorMessageProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px',
        borderLeft: 'none',
        color: theme.palette.gray?.[400],
        minH: '798px',
      }}
      data-testid={props['data-testid']}
    >
      <FontAwesomeIcon
        icon={faCircleExclamation}
        style={{
          color: theme.palette.gray?.[400],
          fontSize: '8rem',
          marginBottom: '1rem',
        }}
      />
      <Text>{message}</Text>
    </Box>
  );
};

export default ErrorMessage;
